export default __webpack_public_path__ + "static/media/2023-01-21-instagram-developer-terms.1878c322.md";